function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.12,
  fill: "#D8DAE7"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 8a2 2 0 11-4 0 2 2 0 014 0zM17.813 14l-3.327 3.326-3.224-3.13c-.793-.77-1.19-1.155-1.643-1.297a2 2 0 00-1.225.01c-.451.148-.842.539-1.624 1.32l-4.236 4.237c.037.088.077.174.12.258a6 6 0 002.622 2.622C6.56 22 8.24 22 11.6 22h.8c3.234 0 4.911 0 6.177-.583a6 6 0 002.769-2.693c.136-.266.243-.55.329-.862L17.812 14z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 18l3.77-3.77c.782-.782 1.173-1.173 1.624-1.322A2 2 0 019.62 12.9c.454.143.85.528 1.643 1.297l3.224 3.13m7.014.361l-1.425-1.424c-.792-.792-1.188-1.188-1.645-1.337a2 2 0 00-1.235 0c-.457.149-.853.545-1.646 1.337l-1.063 1.063M18.5 21.34l-4.014-4.014M18 8a2 2 0 11-4 0 2 2 0 014 0zm-6.4 14h.8c3.36 0 5.04 0 6.324-.654a6 6 0 002.622-2.622C22 17.44 22 15.76 22 12.4v-.8c0-3.36 0-5.04-.654-6.324a6 6 0 00-2.622-2.622C17.44 2 15.76 2 12.4 2h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 00-2.622 2.622C2 6.56 2 8.24 2 11.6v.8c0 3.36 0 5.04.654 6.324a6 6 0 002.622 2.622C6.56 22 8.24 22 11.6 22z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var SvgLandscape = function SvgLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgLandscape;